import React from 'react';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faUndo} from '@fortawesome/pro-regular-svg-icons/faUndo';
import {faRedo} from '@fortawesome/pro-regular-svg-icons/faRedo';
import Cropper from 'react-cropper';

import {Button} from 'Components/Partials/Form';

import ImageUpload from './ImageUpload';

export default class ImageCropper extends React.Component {
    /**
     * @var state
     */
    state = {
        rotation: 0,
        file: null,
        uploading: true,
    };

    /**
     * @var cropperRef
     * @type {null}
     */
    cropperRef = null;

    /**
     * @method componentDidMount
     */
    componentDidMount = () => {
        this.checkForUrl();
    };

    /**
     * @method componentDidUpdate
     */
    componentDidUpdate = (prevProps) => {
        if (this.props.url !== prevProps.url) {
            this.checkForUrl();
        }
    };

    /**
     * @method checkForUrl
     */
    checkForUrl = () => {
        if (this.props.url) {
            this.setState({
                uploading: false
            });
        }
    };

    /**
     * @method handleToggleUploading
     */
    handleToggleUploading = () => {
        this.setState({
            uploading: !this.state.uploading
        });
    };

    /**
     * @method handleOnChange
     */
    handleOnChange = () => {
        if (this.props.onChange !== undefined) {
            this.props.onChange(this.state.file);
        }
    };

    /**
     * @method handleFileInput
     * @param files
     */
    handleFileInput = (files) => {
        this.setState({
            file: files,
        });
        const reader = new FileReader();

        /**
         * @param {ProgressEvent<FileReader>} e
         */
        reader.onload = (e) => {
            this.setState({
                imageUrl: e.target.result,
            }, () => {
                this.handleOnChange();
                this.handleToggleUploading();
            });
        };

        reader.readAsDataURL(files);
    };

    /**
     * @method handleRotateLeft
     */
    handleRotateLeft = () => {
        let {rotation} = this.state;

        rotation -= 90;
        rotation = rotation < 0 ? 270 : rotation;

        this.cropperRef.cropper.rotate(rotation);

        this.setState({
            rotation
        });
    };

    /**
     * @method handleRotateRight
     */
    handleRotateRight = () => {
        let {rotation} = this.state;

        rotation += 90;
        rotation = rotation > 360 ? 90 : rotation;

        this.cropperRef.cropper.rotate(rotation);

        this.setState({
            rotation
        });
    };

    /**
     * @method bubbleData
     */
    getData = () => {
        return this.cropperRef.cropper.getCroppedCanvas({
            maxWidth: 2000,
            maxHeight: 2000,
            fillColor: '#ffffff'
        });
    };

    /**
     * @method render
     * @returns {*}
     */
    render() {
        const {rotation, imageUrl, uploading} = this.state;
        const {url} = this.props;

        if (uploading) {
            return (
                <ImageUpload
                    url={imageUrl ?? url}
                    onChange={this.handleFileInput}
                />
            );
        }

        return (
            <React.Fragment>
                <div className="flex justify-between">
                    <Button onClick={this.handleToggleUploading} label="Upload New" className="mb-4"/>

                    <div>
                        <Button type="button" onClick={this.handleRotateLeft} className="mr-2">
                            <FontAwesomeIcon icon={faUndo}/>
                        </Button>

                        <Button type="button" onClick={this.handleRotateRight}>
                            <FontAwesomeIcon icon={faRedo}/>
                        </Button>
                    </div>
                </div>
                <Cropper
                    src={imageUrl ?? url}
                    initialAspectRatio={16 / 9}
                    guides={false}
                    rotateTo={rotation}
                    rotate={true}
                    ref={ref => this.cropperRef = ref}
                    autoCropArea={1}
                    zoomable={false}
                />
            </React.Fragment>
        )
    }
}
